// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".Gamma." + __webpack_require__.h() + ".chunk.min.js";
};